import { Component, Inject, OnInit } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { animations } from '../../animation/animation'

@Component({
  selector: 'app-bix-alert',
  templateUrl: './bix-alert.component.html',
  styleUrls: ['./bix-alert.component.scss'],
  animations: animations
})
export class BixAlertComponent implements OnInit {

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any,public aleretRef: MatSnackBarRef<BixAlertComponent>) { }

  ngOnInit() {
    // console.log(this.data);
    // alert(window.innerWidth);
  }


  close() {
    this.aleretRef.dismiss()
  }

}

